

























































import { Component, Prop } from 'vue-property-decorator';
import PickerBase from './base';
import ReportMetricsMixin from '@/views/reports/mixins/report-metrics-mixin';
import {forOwn, cloneDeep, debounce} from 'lodash';
import {mixins} from 'vue-class-component';
import { METRICS_CUSTOM_COLUMN, METRICS_CUSTOM_EVENT, METRICS_CUSTOM_EVENT_REVENUE, METRICS_CUSTOM_EVENT_HIDDEN_REVENUE } from '@/services/constants/report';
import query from '@/components/query/query-constructor';


@Component
export default class ReportSorting extends mixins(PickerBase, ReportMetricsMixin) {
  @Prop({
    default: () => {
    }
  }) data: any;

  isFilterMenuOpened: boolean = false;
  silent: boolean = true;
  refresh: boolean = true;

  get options() {
    return [
      {text: '>', value: 'greater'},
      {text: '=', value: 'equals'},
      {text: '<', value: 'lower'}
    ]
  }

  get query() {
    return {
      filterHaving: this.filterHavingValue,
      ...this.form
    }
  }

  form = this.defaultForm;

  get defaultForm() {
    return {
      filterHavingOptions: 'equals',
      filterHavingValues: '0' as any
    };
  }

  get active() {
    return !!this.$store.getters.tableColumnsFiltersForCurrentTab[this.filterHavingValue];
  }

  get filterHavingValue() {
    return (this.data && this.data.header.value) || '';
  }

  get visible() {
    return this.hasFilter?.includes(this.filterHavingValue) ||
        this.filterHavingValue.startsWith(METRICS_CUSTOM_EVENT_REVENUE) ||
        this.filterHavingValue.startsWith(METRICS_CUSTOM_EVENT_HIDDEN_REVENUE) ||
        this.filterHavingValue.startsWith(METRICS_CUSTOM_EVENT) ||
        this.filterHavingValue.startsWith(METRICS_CUSTOM_COLUMN)
  }

  get hasFilter() {
    switch(this.routeName) {
      case 'app.conversions':
        return this.conversionsMetrics.metrics_filters;
      case 'app.postbacks':
        return this.postbacksMetrics.metrics_filters;
      case 'app.errors':
        return this.errorsMetrics.metrics_filters;
      case 'app.live-clicks':
        return this.liveClicksMetrics.metrics_filters;
      case 'app.live-visits':
        return this.liveVisitsMetrics.metrics_filters;

      default:
        return this.baseMetrics.metrics_filters;
    }
  }

  mounted() {
    this.bus.on('report-tab-added', this.onBusReportTabAdded);

    if(!this.isReport()){
      this.applyDataFromUrl()
    }
  }

  beforeDestroy() {
    this.bus.off('report-tab-added', this.onBusReportTabAdded);
  }

  onBusReportTabAdded() {
    this.applyDataFromUrl()
  }

  applyDataFromUrl(){
    const routeParams = query.decode(this.$route.params.data as string);
    if (routeParams?.filterHaving?.length) {
      const index = routeParams.filterHaving.indexOf(this.filterHavingValue);

      if (index !== -1) {
        this.form.filterHavingOptions = routeParams.filterHavingOptions[index] || this.query.filterHavingOptions;
        this.form.filterHavingValues = routeParams.filterHavingValues[index] || this.query.filterHavingValues;
        this.fixForm();
        this.$store.commit('tableAddFilter', this.query);
      }
    }
  }

  get floatRegex() {
    return /^[+-]?\d+(\.\d+)?$/;
  }

  fixForm() {
    const val = (this.form.filterHavingValues + '' || '').replace(',', '.');
    const isValueValid = this.floatRegex.test(val);
    this.form.filterHavingValues = isValueValid ? +val : 0;

    return isValueValid;
  }

  applyFilter() {
    this.fixForm();
    this.$store.commit('tableAddFilter', this.query);
    this.pushURL();
    this.isFilterMenuOpened = false;
  }

  reset() {
    this.$store.commit('tableRemoveColumnsFilter', this.filterHavingValue);
    this.form = cloneDeep(this.defaultForm);
    this.pushURL();
    this.isFilterMenuOpened = false;
  }
}

